<template>
  <Wrapper>
    <main class="main">
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}question` }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ PrivacySentence.breadcrumb[lang] }}
          </router-link>
        </li>
      </ol>
      <h1 class="page-title">{{ PrivacySentence.title[lang] }}</h1>
      <div class="scroll-list">
        <router-link
          v-scroll-to="'#japan-not-eea'"
          to=""
          class="scroll-list__button"
          >{{ PrivacySentence.japan[lang] }}
        </router-link>
        <router-link v-scroll-to="'#eea'" to="" class="scroll-list__button">{{
          PrivacySentence.eea[lang]
        }}</router-link>
      </div>
      <template v-if="lang === 'ja'">
        <section class="sentence-section" id="japan-not-eea">
          <h2>〇&nbsp;日本国内所在者および非EEA所在者</h2>
          <p class="privacy-sentence">
            個人情報の取扱いについて<br />
            一般財団法人東京マラソン財団(以下「当財団」といいます。)は、毎年 3
            月に開催する東京マラソン及び毎年10月に開催する東京レガシーハーフマラソン、その他のランニングイベントの開催を通じて、ランナーをはじめ大会を支えるボランティアや多くの沿道観衆にスポーツに触れる機会を提供しています。<br />
            また、東京マラソン財団オフィシャルクラブ「ONE
            TOKYO」により、加入している会員にランニングやマラソンの様々な情報を発信するなどの事業を展開するとともに、チャリティ事業を行うことにより、社会貢献活動も実施しています。<br />
            当財団は、個人情報の重要性を認識し、その保護に最大限の注意を払って取り扱います。<br />
            当財団は、東京マラソン及び東京レガシーハーフマラソン、その他のランニングイベントをはじめとする当財団事業（以下「東京マラソン等」といいます。）の実施にあたり、当財団が保有する東京マラソン等の応募者及び参加者の個人情報の保護について次のとおり取り組んでいます。<br /><br />
            1. 法令、国が定める指針その他の規範の遵守について<br />
            当財団は、個人情報の取得、利用及び提供を必要とする場合には、個人情報の保護に関する法律（平成15年法律第57号。以下「個人情報保護法」といいます。）その他の関連法令並びに法令及び規則に基づく義務に準拠した一般財団法人東京マラソン財団個人情報の保護に関する規程（以下「当財団規程」といいます。）を遵守し、厳正な管理のもとで行います。<br /><br />
            2. 個人情報の取得、利用及び提供について<br />
            当財団は、個人情報の取得、利用及び提供を必要とする場合には、日本工業規格「個人情報保護マネジメントシステム
            要求事項」(JIS Q
            15001:2006)に準拠した当財団の個人情報保護マネジメントシステムを遵守し、厳正な管理のもとで行います。<br />
            当財団が個人情報を取得するにあたっては、ご本人の意思による（ご本人が未成年者（18歳未満）の場合はその親権者の同意を得た）情報の提供(登録、申込等)によることを原則とします。<br />
            当財団が個人情報を取扱うにあたっては、その利用目的を事前に明示し、明示した利用目的を達成するために必要な範囲内でこれを行います。<br />
            (1) 取り扱う個人情報<br />
            当財団は、以下に掲げる個人情報を取り扱います。<br />
            ・東京マラソン等にご応募いただく場合<br />
            ・東京マラソン等を通じて寄付をしていただく場合<br />
            応募者が東京マラソン等にエントリーする場合、当財団は応募者から提供いただいた応募者情報（応募者の氏名、性別、生年月日、年齢、住所、電話番号、携帯電話番号、電子メールアドレス、国籍、パスポート番号（海外エントリーの場合）並びに緊急連絡先の氏名、電話番号及び応募者との関係、日本陸上競技連盟（JAAF）への登録の有無、JAAF
            ID等）、応募者のレース種目情報（応募者の障害（視覚障害、知的障害、車いす）の有無、臓器移植の有無、伴走者の有無）（該当する場合）、寄付者情報（所属先、住所、電話番号、部署名、役職、担当者氏名、担
            当者電子メールアドレス、担当者電話番号等）及び寄付情報（寄付先団体名、寄付金額、寄付に関するアンケート回答等）を含む個人情報を取得し、取り扱います。<br />
            ・東京マラソン等にご参加いただく場合<br />
            東京マラソン等に参加する前に、東京マラソン参加前の体調、ワクチンの接種履歴の有無及びPCR検査その他の感染症検査の結果を取得することがあります。<br />
            東京マラソン等に参加する場合、上記のデータのほか、顔写真、カメラ映像、本大会記録並び本大会中の中途記録及び推定走行位置情報を含むデータを取得し、取り扱います。<br />
            当財団は、ランナーが参加者本人であることを確認するため参加者の顔写真を撮影し、本大会中におけるコースの安全管理のために監視カメラ映像（参加者の容貌が写り込むことがあります。）を撮影し、これらを取り扱います。<br />
            ・救護又は病院への搬送が必要となった場合<br />
            東京マラソン等大会時の宿泊先の名前及び電話番号、現在治療中の病気、現在服用中の薬、アレルギー、傷病名、症状、発生場所、処置の内容（もしあれば）等の必要な情報を取得し、搬送先の病院に提供します。<br />
            また、病院へ搬送された場合には、当財団は、補償を含む事故後の対応並びに今後の東京マラソン等における救護スタッフの配置、緊急車両の配備数及び台数その他の安全に関する事項の検討及び改善のため、傷病名、症状経過、治療経過及び現在の処方について当該病院から取得します。<br />
            (2) 個人情報の取扱いの目的<br />
            当財団は、以下に掲げる目的又はご本人に通知した目的の達成のために個人情報を取り扱います。<br />
            ・東京マラソン等にご応募いただくため<br />
            ・東京マラソン等を通じて寄付をしていただくため<br />
            -参加者の抽選及び登録のため<br />
            -大会応募者及び参加者へのサービス及び安全の向上<br />
            -大会協賛企業・協力・関係団体からの情報提供<br />
            -本方針に定める第三者への個人情報の提供<br />
            ・東京マラソン等にご参加いただくため<br />
            上記目的のほか、以下に掲げる目的のため<br />
            -参加者の本人確認<br />
            -感染症拡大防止のため（感染の有無の確認及び保健所その他の管轄行政機関への報告を含みます。）<br />
            -マラソンコースの安全管理<br />
            -参加案内の送付、記録通知、関連情報の通知<br />
            -大会中の中途記録及び推定走行位置情報発表並びに大会記録発表（ランキング含みます。）<br />
            -保険加入<br />
            -救護サービスの提供<br />
            -補償を含む事故後の対応<br />
            -次回東京マラソン等における救護スタッフの配置、緊急車両の配備数及び場所その他の安全に関する事項の検討<br />
            -その他東京マラソン等の実施運営<br />
            -東京マラソン等に関する統計調査<br />
            (3) 第三者提供<br />
            当財団は、あらかじめ同意をいただいている場合や法令等に基づく場合等を除き、原則として個人情報を第三者に対して提供いたしません。なお、本大会運営に関わる範囲内（感染症拡大予防措置を講じることを含みます。）で保健所その他の管轄行政機関、関連事業者（アボット・ワールドマラソンメジャーズを運営するアメリカ合衆国所在のWorld
            Marathon Majors
            LLCを含みます。当該提供に関して個人情報保護法28条2項に基づく情報は下記のとおりです。）、寄付先団体及び委託業者へ提供する必要がある場合、保険加入の申請のために保険会社より提供を求められた場合、ご提供いただいたご健康・診療に関する情報を搬送先の医療機関に提供する場合、記録に係る情報をテレビ・新聞・雑誌・インターネット等へ掲載する場合に第三者（日本国外にある者を含みます。）に対して提供することがあります。<br /><br />
            当財団は、あらかじめ同意をいただき、2.(1)「取り扱う個人情報」記載の個人情報を以下の国に所在する第三者に提供いたします。<br />
            ① 外国の名称<br />
            アメリカ合衆国<br />
            ② 当該外国における個人情報の保護に関する制度<br />
            下記の URL より内容をご確認ください。<br />
            <a
              href="https://www.ppc.go.jp/files/pdf/USA_report.pdf"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >アメリカ合衆国（連邦法）</a
            >
            <a
              href="https://www.ppc.go.jp/files/pdf/illinoi_report.pdf"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >イリノイ州法</a
            >
            <br />
            ③ 外国にある第三者が講ずる個人情報の保護のための措置<br />
            提供先の第三者は、OECDプライバシーガイドライン８原則に対応する措置を全て講じています。<br />
            (4) 要配慮個人情報<br />
            上記2(1)の障害（視覚障害、知的障害、車いす）の有無、臓器移植の有無、伴走者の有無は、参加するレース種目（車いす、視覚障害、知的障害、臓器移植者）の特定（大会記録公表時を含みます。）のために必要な範囲でのみ取り扱います。<br />
            上記2(1)の健康情報・医療情報は、(i)東京マラソン等における感染症拡大予防のため（感染の有無の確認及び保健所その他の管轄行政機関への報告を含みます。）
            、及び(ii)救護サービスの提供、補償を含む事故後の対応、次回東京マラソン等における救護スタッフの配置、緊急車両の配備数及び場所その他の安全に関する事項の検討のために必要な範囲でのみ取り扱います。<br /><br />
            3. 個人情報の漏えい、改竄、滅失又はき損の防止について<br />
            当財団が個人情報を取扱うにあたっては、正確かつ最新の状態で保管・管理するよう努めるとともに、当財団のセキュリティ施策を実施することにより個人情報の漏えい、滅失、き損又は改竄の防止を行い、厳正な管理のもとで安全に蓄積・保管します。
            当財団における個人情報の取得体制及び講じている措置の内容の詳細については下記7記載の「お客様相談窓口」の連絡先までお問い合わせください。<br />
            また、当財団は、個人情報を取り扱う従業員や個人情報の取扱いを委託した場合における委託先について、適切に監督します。<br /><br />
            個人情報取扱事業者の名称は、一般財団法人東京マラソン財団であり、住所及び代表者氏名については、
            <a
              href="https://tokyo42195.org/aboutus/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >こちら</a
            >
            からご確認ください。<br />
            4. 個人情報保護マネジメントシステムの継続的改善について<br />
            当財団は、個人情報保護マネジメントシステムの継続的改善を行います。<br /><br />

            5. クッキー等の取得について<br />
            当財団では、当財団のウェブサイトにおいて、当財団ウェブサイトを閲覧する者（以下「閲覧者」といいます。）
            のクッキー、デバイス情報、ソフトウエア情報等を収集することがあります。当財団のウェブサイトはこれらの情
            報を当財団のウェブサイトの利用動向等の調査、分析を行うための一般的な統計情報として利用するものであり、
            個人情報の特定は行っておりません。<br /><br />
            当財団では、閲覧者の利用状況の把握・分析をするために、GoogleのGoogleアナリティクスを利用しています。
            Googleアナリティクスでは、当財団のクッキーを利用して、閲覧者の情報を収集しています。Googleアナリティ
            クスにより収集された情報はGoogleにより、以下の同社の利用規約及びプライバシーポリシーに基づき管理され
            ます。Googleアナリティクスによるデータの収集・処理の仕組みについては、以下の「Googleのサービスを使用
            するサイトやアプリから収集した情報のGoogleによる使用」をご確認ください。また、閲覧者が当財団ウェブサ
            イトでのGoogleアナリティクスによる情報収集を拒否される場合は、下記「Googleアナリティクスオプトアウ
            ト アドオン」機能により情報収集を停止することができます。<br />
            Google アナリティクスの利用規約<br />
            <a
              href="https://marketingplatform.google.com/about/analytics/terms/jp/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://marketingplatform.google.com/about/analytics/terms/jp/</a
            >
            <br />
            Google のプライバシーポリシー<br />
            <a
              href="http://www.google.com/intl/ja/policies/privacy/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >http://www.google.com/intl/ja/policies/privacy/</a
            >
            <br />
            Googleのサービスを使用するサイトやアプリから収集した情報のGoogleによる使用<br />
            <a
              href="https://www.google.com/intl/ja/policies/privacy/partners/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://www.google.com/intl/ja/policies/privacy/partners/</a
            >
            <br />
            Google アナリティクス オプトアウトアドオン<br />
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=ja"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://tools.google.com/dlpage/gaoptout?hl=ja</a
            >
            <br /><br />

            6. 開示対象個人情報の開示等の手続について<br />
            当財団が保有する個人情報の開示（第三者提供記録の開示も含みます。）、訂正等、利用停止等及び第三者提供の停止の申出は、
            当財団規程及び一般財団法人東京マラソン財団個人情報窓口対応要綱(以下「当財団要綱」といいます。）に定める方法によりお受けいたします。開示対象個人情報の開示の申出の場合は、当財団要綱に定める「開示対象個人情報開示申出書」(pdf
            形式)を提出していただきます。PDF ファイルを見るには、Adobe Acrobat
            Readerのインストール が必要です。<br />
            開示対象個人情報の開示を写しの交付の方法により行うときは、当財団規程の定めるところにより費用を負担していただきます。<br /><br />
            7. 個人情報ご相談窓口について<br />
            当財団の個人情報の取扱いに関して苦情及び相談は、下記お客さま相談窓口までお電話、電子メール又は郵送のいずれかの方法にてお申し出ください。<br />
            一般財団法人東京マラソン財団 お客さま相談窓口<br />
            〒160-0023 東京都新宿区西新宿3-6-11西新宿KSビル8階
            <br />
            Tel:03-6279-0044 Fax:03-6279-0144<br />
            メールでのお問い合わせ<br />
            daihyo@tokyo42195.org<br />
            受付時間:平日10:00～17:00（土日、祝日、年末年始を除く。）<br /><br />
            8. 本方針の変更について<br />
            当財団は、適宜本方針の内容を変更することができます。本方針の内容を変更した場合は、本サイト上に提示し、お知らせしますので、適時に本方針の内容をご確認下さいますようお願いいたします。本方針を変更した後、応募者及び参加者が本方針を閲覧した時点でその利用者は変更後の本方針に同意したものとみなされます。<br /><br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、平成２５年４月１日から施行する。<br /><br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、平成３０年６月２８日から施行する。<br /><br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、令和２年７月１日から施行する。<br /><br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、令和２年１１月１１日から施行する。<br /><br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、令和４年７月１１日から施行する。<br /><br />
          </p>
          <p class="privacy-sentence text-align-right">
            一般財団法人東京マラソン財団 理事長<br />
          </p>
        </section>
        <section class="sentence-section" id="eea">
          <h2>〇&nbsp;EEA所在者</h2>
          <p class="privacy-sentence">
            &emsp;*欧州経済地域（EEA） :
            ＥＵ（欧州連合）全28カ国にノルウェー、リヒテンシュタイン、アイスランドを含めた31カ国<br /><br />
            個人データの取扱いについて<br />
            一般財団法人東京マラソン財団（以下「当財団」といいます。）は、個人データの重要性を認識し、その保護に最大限の注意を払って取り扱います。<br />
            本プライバシーポリシーは、東京マラソン及び東京レガシーハーフマラソン、その他のランニングイベントをはじめとする当財団事業（以下「東京マラソン等」といいます。）のを実施するにあたり、欧州経済領域（EEA）に所在する応募者、参加者及び当財団ウェブサイトを閲覧する者（以下「閲覧者」といいます。）から取得した個人データの取扱いに適用されます。<br /><br />
            １．個人データの種類<br />
            本プライバシーポリシーにおいて、個人データとは、特定の又は特定し得る自然人に関するデータをいいます。当財団は、以下の個人データを収集し、取り扱うことがあります。なお、以下の個人データには、内容により法令上の個人データに該当しないものも含まれることがあります。<br /><br />
            (1)
            東京マラソン等にご応募いただく場合及び東京マラソン等を通じて寄付をしていただく場合<br />
            応募者が東京マラソン等にエントリーする場合、当財団は応募者から提供いただいた応募者情報（応募者の氏名、性別、生年月日、年齢、住所、電話番号、携帯電話番号、電子メールアドレス、国籍、パスポート番号（海外エントリーの場合）並びに緊急連絡先の氏名、電話番号及び応募者との関係、日本陸上競技連盟（JAAF）への登録の有無、JAAF
            ID等）、応募者のレース種目情報（応募者の障害（視覚障害、知的障害、車いす）の有無、臓器移植の有無、伴走者の有無）（該当する場合）、寄付者情報（所属先、住所、電話番号、部署名、役職、担当者氏名、担当者電子メールアドレス、担当者電話番号等）及び寄付情報（寄付先団体名、寄付金額、寄付に関するアンケート
            回答等）を含む個人データを取得し、取り扱います。<br /><br />
            (2) 東京マラソン等にご参加いただく場合<br />
            ・参加者から提供いただく情報<br />
            東京マラソン等に参加する前に、本大会参加前の体調、ワクチンの接種履歴の有無及びPCR検査その他の感染症検査の結果を取得することがあります。<br />
            東京マラソン等に参加する場合、当財団は上記（１）のデータのほか、顔写真、監視カメラ映像、本大会記録並び本大会中の中途記録及び推定走行位置情報を含むデータを取得し、取り扱います。<br />
            当財団は、ランナーが参加者本人であることを確認するため参加者の顔写真を撮影し、本大会中におけるコースの安全管理のために監視カメラ映像（参加者の容貌が写り込むことがあります。）を撮影し、これらを取り扱います。<br />
            また、参加者が受傷して救護が必要となった場合、当財団は本大会時における宿泊先名及び電話番号、現在治療中の病気、現在服用中の薬並びにアレルギー、傷病名、症状、発生場所及び処置の内容（もしあれば）等の必要な情報を取得し、これらを取り扱います。さらに、参加者が病院に搬送された場合、当財団は当該データを病院に提供します。<br />
            ・病院から取得する情報<br />
            東京マラソン等参加前のPCR検査その他の感染症検査実施の結果、陽性と判断された場合、本大会における感染症拡大防止のため、PCR検査その他の感染症検査の結果を当該検査を実施した医療機関から取得します。<br />
            参加者が病院に搬送された場合、当財団は、補償を含む事故後の対応並びに次回の東京マラソン等大会における救護スタッフの配置、緊急車両の配備数及び台数その他の安全に関する事項の検討及び改善のため、傷病名、症状経過、治療経過及び現在の処方について当該病院から取得します。<br /><br />
            (3) 当財団ウェブサイトを閲覧される場合<br />
            閲覧者が当財団ウェブサイトを閲覧される場合、閲覧者のクッキー、デバイス情報、ソフトウエア情報、当財団Webサイトのアクセス履歴等を取得する場合があります。<br /><br />
            ２．法令及び規則に基づく義務並びに適用されるすべての法令の遵守<br />
            当財団は、個人データの取得、利用及び提供を必要とする場合には、EU一般データ保護規則（GDPR）その他の関連法令並びに法令及び規則に基づく義務に準拠した一般財団法人東京マラソン財団個人情報の保護に関する規程（以下「当財団規程」といいます。）を遵守し、厳正な管理のもとで行います。<br /><br />
            ３．個人データの取得、利用及び提供<br />
            当財団は、個人データの取得、利用及び提供を必要とする場合には、日本工業規格「個人情報保護マネジメントシステム
            要求事項」(JIS Q
            15001:2006)に準拠した当財団の個人情報保護マネジメントシステムを遵守し、厳正な管理のもとで行います。<br />
            当財団が個人データを取扱うに当たっては、その利用目的を事前に明示し、明示した利用目的を達成するために必要な範囲内でこれを行います。<br /><br />
            (1) 個人データの取扱いの目的<br />
            当財団は、応募者、参加者及び閲覧者の個人データを個別に通知し、又は以下に定める目的を達成するために取り扱います。<br />
            ・ 東京マラソン等にご応募いただくため<br />
            ・ 東京マラソン等を通じて寄付をしていただくため<br />
            参加者の抽選及び登録のため<br />
            大会応募者及び参加者へのサービス及び安全の向上<br />
            大会協賛企業・協力・関係団体からの情報提供<br />
            本プライバシーポリシーに定める第三者への個人情報の提供<br />
            ・東京マラソン等にご参加いただくため<br />
            上記目的のほか、以下に掲げる目的のため<br />
            参加者の本人確認<br />
            感染症拡大防止のため（感染の有無の確認及び保健所その他の管轄行政機関への報告を含みます。）<br />
            マラソンコースの安全管理<br />
            参加案内の送付、記録通知、関連情報の通知<br />
            大会中の中途記録及び推定走行位置情報発表並びに大会記録発表（ランキング含みます。）<br />
            保険加入<br />
            救護サービスの提供<br />
            補償を含む事故後の対応<br />
            次回東京マラソン等大会における救護スタッフの配置、緊急車両の配備数及び場所その他の安全に関する事項の検討<br />
            その他東京マラソン等本大会の実施運営<br />
            東京マラソン等に関する統計調査<br />
            ・当財団のウェブサイトの改善のため<br />
            当財団のウェブサイトの利用動向等の調査及び分析<br />
            当財団のウェブサイトのサービス改善<br />
            (2)&emsp;追加的取扱い<br />
            上記以外の目的で応募者、参加者及び閲覧者の個人データを取り扱う場合、当財団は、事前に、当該追加的取扱い目的及び関連法令に基づき必要とされる事項につき、当該応募者、参加者及び閲覧者に通知します。<br />
            (3)&emsp;法的根拠<br />
            当財団は、上記（１）の目的のため、応募者及び参加者の本プライバシーポリシーに対する同意、契約の履行（契約の締結前に手段を講じるために必要となる場合を含む。）及び当財団の事業を遂行するための正当な利益に基づき応募者、参加者及び閲覧者の個人データを取り扱うことを原則とします。<br />
            応募者及び参加者はいつでもかかる同意を撤回することができます。ただし、当該同意の撤回がなされる前にされたいかなる個人データの取扱いの法的正当性に影響を与えません。同意を撤回される場合には、8.記載のお客さま相談窓口にご連絡下さい。<br />
            18歳未満の応募者、参加者及び閲覧者から個人データを取得するにあたっては、必ず保護者の方の同意又は保護者の方の許可を得た同意をいただいております。18歳未満の方は、サービス（マラソンへの応募及び参加並びにランキング掲載を含みますがこれらに限られません。以下同じ。）を利用される前に、保護者の方に同意を行っていただくか、同意に対して保護者の方の許可をいただくようお願いいたします。<br />
            (4)&emsp;個人データ提供の必要性<br />
            応募者及び参加者に提供していただく個人データは、当財団が応募者及び参加者にサービスを提供する上で、応募者及び参加者にご提供いただくことが必要なものですので、ご提供いただけない応募者及び参加者には、東京マラソン等へのご応募・本大会を通じて寄付又は本大会にご参加いただけない場合があります。<br />
            (5)&emsp;保存期間<br />
            当財団は、応募者、参加者及び閲覧者にサービスを提供するために必要がある限り、応募者、参加者及び閲覧者の個人データを保持しますが、必要性がなくなった場合には、速やかにこれを消去します。当財団の保存期間を決定するために使用される基準には、以下が含まれます。(i)応募者、参加者及び閲覧者との継続的な関係の期間、(ii)当財団が従うべき法的義務の有無、及び(iii)応募者、参加者及び閲覧者が当事者である契約を履行するための必要性の有無。<br />
            (6)&emsp;個人データの移転<br />
            当財団は応募者、参加者及び閲覧者の個人データを、保健所その他の管轄行政機関、当財団の子会社や関連会社、クラウドベンダーやサービス運営会社等の当財団業務委託先会社、寄付先団体、病院その他の医療機関をはじめとする第三者に対して提供し、応募者、参加者及び閲覧者の個人データは上記で特定された利用目的のため、当該第三者により処理されます。<br />
            その結果、応募者、参加者及び閲覧者の個人データは、EEA域外の国又は管轄区域（日本、アメリカ合衆国を含みますがこれらに限りません。以下同じ。）にある者に対し提供されることがあります。当該国又は管轄区域においては、EEAと同じデータ保護法が整備されておらず、EEAにおいてデータ主体に与えられる多くの権利が与えられないことがありますのでご注意ください。<br />
            また、当財団は、応募者、参加者及び閲覧者の個人データを、EEA域内及び欧州委員会がEU一般データ保護規則第45条に基づき十分なデータ保護の水準を確保していると認める決定を行った国以外の国にある第三者に提供する場合には、EU
            一般データ保護規則に基づく標準契約条項の締結等により、応募者、参加者及び閲覧者の個人データの保護に関する十分な措置が確保されるよう担保いたします。応募者及び参加者の個人データを保護するために用いられている文書の写しを入手するなど、詳細な情報を得る場合には、8.記載のお客さま相談窓口にご連絡下さい。<br />
            (7)&emsp;センシティブデータ<br />
            上記１(1)の障害（視覚障害、知的障害、車いす）の有無、臓器移植の有無、伴走者の有無は参加するレース種目（車いす、視覚障害、知的障害、臓器移植者）の特定（大会記録公表時を含みます。）のために必要な範囲でのみ取り扱います。<br />
            上記1(2)の健康情報・医療情報は、(i)東京マラソンにおける感染症拡大予防のため（感染の有無の確認及び保健所その他の管轄行政機関への報告を含みます。）、及び(ii)救護サービスの提供、補償を含む事故後の対応、次回東京マラソン等大会における救護スタッフの配置、緊急車両の配備数及び場所その他の安全に関する事項の検討のために必要な範囲でのみ取り扱います。<br /><br />
            ４．個人データの漏えい、改竄、滅失又はき損の防止について<br />
            当財団が個人データを取扱うに当たっては、正確かつ最新の状態で保管・管理するよう努めるとともに、当財団のセキュリティ施策を実施することにより個人データの漏えい、滅失、き損又は改竄の防止を行い、厳正な管理のもとで安全に蓄積・保管します。<br />
            また、当財団は、個人データを取り扱う従業員や個人データの取扱いを委託した場合における委託先について、適切に監督します。<br /><br />
            ５．個人情報保護マネジメントシステムの継続的改善について<br />
            当財団は、個人情報保護マネジメントシステムの継続的改善を行います。<br /><br />
            ６. クッキー等の取得について<br />
            当財団では、当財団のウェブサイトにおいて、当財団のウェブサイトの閲覧者のクッキー、デバイス情報、ソフトウエア情報等を収集することがあります。当財団のウェブサイトはこれらの情報を当財団のウェブサイトの利用動向等の調査、分析を行うための一般的な統計情報として利用するものであり、個人情報の特定は行っておりません。<br /><br />
            当財団では、閲覧者の利用状況の把握・分析をするために、GoogleのGoogleアナリティクスを利用しています。Googleアナリティクスでは、
            当財団のクッキーを利用して、閲覧者の情報を収集しています。Googleアナリティクスにより収集された情報はGoogleにより、
            以下の同社の利用規約及びプライバシーポリシーに基づき管理されます。Googleアナリティクスによるデータの収集・処理の仕組みについては、
            以下の「Googleのサービスを使用するサイトやアプリから収集した情報のGoogleによる使用」をご確認ください。
            また、閲覧者が当財団ウェブサイトでのGoogleアナリティクスによる情報収集を拒否される場合は、
            下記「Googleアナリティクスオプトアウトアドオン」機能により情報収集を停止することができます。<br />
            Google アナリティクスの利用規約<br />
            <a
              href="https://marketingplatform.google.com/about/analytics/terms/jp/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://marketingplatform.google.com/about/analytics/terms/jp/</a
            >
            <br />
            Google のプライバシーポリシー<br />
            <a
              href="http://www.google.com/intl/ja/policies/privacy/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >http://www.google.com/intl/ja/policies/privacy/</a
            >
            <br />
            Googleのサービスを使用するサイトやアプリから収集した情報のGoogleによる使用<br />
            <a
              href="https://www.google.com/intl/ja/policies/privacy/partners/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://www.google.com/intl/ja/policies/privacy/partners/</a
            >
            <br />
            Google アナリティクス オプトアウトアドオン<br />
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=ja"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://tools.google.com/dlpage/gaoptout?hl=ja</a
            >
            <br /><br />
            ７．応募者、参加者及び閲覧者の権利<br />
            応募者、参加者及び閲覧者は、応募者、参加者及び閲覧者について当財団が保持する個人データへのアクセス、訂正若しくは消去若しくは取扱いの制限又はデータポータビリティを請求することができます。<br />
            応募者、参加者及び閲覧者は、応募者、参加者及び閲覧者に関連する個人データの処理につき、当財団又は応募者、参加者及び閲覧者の居住地を管轄するデータ保護当局に対して異議を申し立てる権利を有します。<br />
            当財団が保有する個人情報の開示、訂正及び利用停止の申出は、当財団規程及び一般財団法人東京マラソン財団個人情報窓口対応要綱（以下「当財団要綱」といいます。）に定める方法によりお受けいたします。開示対象個人情報の開示の申出の場合は、当財団要綱に定める「開示対象個人情報開示申出書」(pdf
            形式)を提出していただきます。PDF ファイルを見るには、Adobe Acrobat
            Readerのインストール が必要です。<br /><br />
            ８．お問い合わせ<br />
            応募者、参加者及び閲覧者の個人データの取扱い目的及び手段の決定は、当財団が行っております。
            本プライバシーポリシー若しくは当財団の個人データの処理についてのご相談若しくは疑問又は個人データのアクセス、訂正、消去、取扱いの制限、データポータビリティの権利に関してご請求等がある場合は、以下のお客さま相談窓口までお電話、電子メール又は郵送のいずれかの方法によりお申し出ください。<br /><br />
            一般財団法人東京マラソン財団 お客さま相談窓口<br />
            〒160-0023 東京都新宿区西新宿3-6-11西新宿KSビル8階
            <br />
            Tel:03-6279-0044 Fax:03-6279-0144<br />
            メールでのお問い合わせ<br />
            daihyo@tokyo42195.org<br />
            受付時間:平日10:00～17:00（土日、祝日、年末年始を除く。）<br /><br />
            ９．本プライバシーポリシーの変更について<br />
            当財団は、適宜本プライバシーポリシーの内容を変更することができます。本プライバシーポリシーの内容を変更した場合は、本サイト上に提示し、お知らせしますので、適時に本プライバシーポリシーの内容をご確認下さいますようお願いいたします。本プライバシーポリシーを変更した後、応募者、参加者及び閲覧者が本プライバシーポリシーを閲覧した時点でその利用者は変更後の本プライバシーポリシーに同意したものとみなされます。<br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、平成２５年４月１日から施行する。<br /><br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、平成３０年６月２８日から施行する。<br /><br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、令和２年７月１日から施行する。<br /><br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、令和２年１１月１１日から施行する。<br /><br />
            &emsp;附&emsp;則<br />
            &emsp;この要綱は、令和４年７月１１日から施行する。<br /><br />
          </p>
          <p class="privacy-sentence text-align-right">
            一般財団法人東京マラソン財団 理事長<br />
          </p>
        </section>
      </template>
      <template v-else>
        <section class="sentence-section" id="japan-not-eea">
          <h2
            >〇&nbsp;For applicants based in the European Economic Area
            (EEA)</h2
          >
          <p class="privacy-sentence">
            The Tokyo Marathon Foundation (also referred to as "we" or "us")
            understands the importance of the personal data collected from
            applicants, participants, or visitors to our website ("Visitors")
            and will make sure to handle such data with the utmost care.<br />
            <br />
            This Privacy Policy governs our privacy practices with respect to
            all running events held by us, including, but not limited to, the
            Tokyo Marathon and Tokyo Legacy Half Marathon (the "Events"), for
            processing the personal data we collect from each applicant,
            participant, or Visitors in the European Economic Area ("EEA").<br />
            <br />
            1. Types of personal data<br />
            In this Privacy Policy, 'personal data' means any data relating to
            an identified or identifiable natural person. We may collect and
            process the following types of personal data. Please note that some
            of the following types of data may not fall under personal data
            under the applicable law, depending on the contents thereof.<br />
            (1) When applying to participate in the Events and/or when donating
            through the Events<br />
            When applicants apply to participate in the Events, we collect and
            process personal data of applicants (such as the applicants' name,
            sex, date of birth, age, address, telephone number, mobile number,
            email address, nationality, passport number (if applicant
            participates from overseas), emergency contact name, telephone
            number, relationship of such emergency contact with the applicants,
            whether applicants are registered with the Japan Association of
            Athletics Federations (JAAF), JAAF ID), race information of
            applicants (such as whether the applicant has any disability (visual
            disability, intellectual disability and/or the use of a wheelchair),
            whether the applicant is an organ transplant recipient and whether
            the applicant needs an escort runner)(if applicable), donor
            information (such as name of company; address; telephone number;
            department; position; and contact person's name, email address, and
            telephone number), and charity information (such as name of the
            charity organizations to which applicants donate, amount of
            donation, and questionnaire responses); all of which are data
            provided to us by the applicants.<br />
            (2) When selected applicants participate in the Events <br />
            ・Personal data that participants provide to us<br />
            We may collect information regarding the participants' health
            condition, vaccination history, PCR test results, and other
            infectious disease tests result prior to participating in the
            Events.<br />
            When participants participate in the Events, we collect and process
            personal data including each participant's face photo, surveillance
            footage, race results and intermediate race record and estimated
            runner location information during the race, in addition to the
            personal data set forth in (1) above.<br />
            In order to verify the identity of the participants, we collect and
            process participants' face photos; and we collect and process
            surveillance footage of the course during the race (participants'
            appearance may be recognized in such footage) for safety reasons.<br />
            In addition, if a participant suffers an injury and needs medical
            care, we will collect and process the necessary data such as name
            and phone number of the hotel where the participant is staying,
            current medical conditions, current medications, allergies, disease
            or injury name, symptoms, site of occurrence and the treatment
            received (if any). Further, if a participant is transferred to the
            hospital, we will provide such data to the hospital.<br />
            ・Personal data that we obtain from hospitals<br />
            When the PCR test results or other tests results for infectious
            diseases conducted before the Events are positive, we collect the
            results from the medical institution that conducted such tests to
            prevent the spread of infectious diseases at the Events.<br />
            If a participant is transferred to the hospital, we collect and
            process data on the disease or injury name, course of symptoms,
            course of treatment, and current prescriptions, from the hospital,
            in order to respond in the wake of an accident, including indemnity,
            examination and improvement of the places for distributing emergency
            staff, the number and places for distribution of emergency vehicles,
            and any other matters concerning safety for future Events.<br />
            (3) When visiting our website <br />
            When Visitors visit our website, we may collect cookies, device
            information, software information, and website browsing history,
            etc.<br />
            <br />
            2. Compliance with statutory and regulatory obligations and all
            applicable laws<br />
            We strive to use and strictly manage the personal data we collect,
            use, and disclose in compliance with the Tokyo Marathon Foundation's
            privacy protection regulations, which are set in accordance with the
            General Data Protection Regulation (Regulation (EU) 2016/679) and
            all other applicable statutory and regulatory obligations and
            laws.<br />
            3. Collection, use and disclosure of personal data<br />
            The Tokyo Marathon Foundation collects, uses, and discloses the
            personal data we hold in compliance with our personal data
            protection management system, which is designed to adhere with the
            Personal Information Protection Management System requirements of
            the Japanese Industrial Standards set forth in JIS Q 15001:2006.<br />
            The purposes for collecting and processing personal data are
            specified in advance, and the Tokyo Marathon Foundation limits the
            collection and processing of personal data to what is necessary to
            achieve the previously advised purposes.<br />
            (1) Purposes of use of personal data<br />
            The Tokyo Marathon Foundation processes the personal data of
            applicants, participants, and Visitors in order to achieve the
            purposes notified individually to applicants, participants, or
            Visitors or as set forth below:<br />
            ・For applicants to the Events and/or for applicants making a
            donation through the Events:<br />
            - to select and registering participants;<br />
            - to improve our services and safety levels for
            applicants/participants;<br />
            - to provide information from the sponsors, supporting organizations
            and related organizations; and<br />
            - to provide personal data to the third parties as set forth in this
            Privacy Policy.<br />
            ・For participants in the Events:<br />
            In addition to the purposes set forth above, we will process
            participants' personal data for the purposes set forth below:<br />
            - to verify the identity of the participants;<br />
            - to prevent the spread of infectious diseases (including
            investigation of the presence or absence of infection and reporting
            to public health centers and other administrative agencies);<br />
            - to ensure safety control of the marathon course;<br />
            - to deliver the Runner Handbook, results, and relevant information
            related to the Events to the participants;<br />
            - to announce intermediate record and estimated runner location
            information during the race and race results (including
            rankings);<br />
            - to subscribe to insurance;<br />
            - to provide medical care;<br />
            - to provide support in the wake of an accident, including
            indemnity;<br />
            - to examine and improve the places for distributing emergency
            staff, the number and places for distribution of emergency vehicles,
            and any other matters concerning safety for future Events;<br />
            - to hold and manage the Events; and<br />
            - to compile statistics from the Events.<br />
            ・For improvement of our website:<br />
            - to research and analyze trends in the use of our website; and<br />
            - to improve our website and services.<br />
            <br />
            (2) Additional processing<br />
            In the case of processing the personal data of applicants,
            participants, or Visitors for purposes other than the above, the
            Tokyo Marathon Foundation will notify the relevant persons in
            advance of such purposes of use and other matters as required by
            applicable law.<br />
            (3) Legal basis for collection and use<br />
            The Tokyo Marathon Foundation will, in principle, process the
            personal data of applicants, participants, and Visitors on the basis
            of our legitimate interests in conducting our business, on the basis
            of performing or entering into a contract, and on the basis of
            consent for the Tokyo Marathon Foundation to do so when
            applicants/participants indicated their acceptance of this Privacy
            Policy.<br />
            The applicants/participants may withdraw such consent at any time;
            provided, however, that this will not affect the lawfulness of any
            processing carried out before their withdrawal of such consent. When
            applicants/participants want to withdraw their consent, please
            contact us at the addresses indicated in "8. Inquiries."<br />
            In obtaining personal data from applicants, participants, or
            Visitors under the age of eighteen (18), we will, at all times, ask
            for such person's guardian's consent or the consent authorized by
            the guardian. In the event that anyone under the age of eighteen
            (18) wishes to use the services (including, without limitation, for
            applying/participating in the marathon, and ranking; the same shall
            apply hereafter), we ask them to make sure that consent is given or
            authorized by their guardian.<br />
            (4) Necessity of providing personal data<br />
            The personal data that the applicants/participants are to provide is
            necessary for the Tokyo Marathon Foundation to provide services to
            the applicants/participants. Therefore, there may be cases where
            applicants/participants who have not provided such data will be
            unable to apply to participate in the Events, donate through the
            Events, or participate in the Events.<br />
            (5) Retention period<br />
            The Tokyo Marathon Foundation will retain the personal data of
            applicants, participants, and Visitors if such data is necessary to
            provide the services to them, but we will promptly delete the same
            in the case such data is no longer necessary. The criteria used to
            determine our storage periods include: (i) the length of time we
            have an ongoing relationship with applicants, participants, and
            Visitors; (ii) whether there is any legal obligation to which we are
            subject; and (iii) whether there is a need in order to perform a
            contract to which they are party.<br />
            (6) Transfer of personal data<br />
            The Tokyo Marathon Foundation may provide the personal data of
            applicants, participants, or Visitors to third parties such as
            public health centers and other administrative agencies,
            subsidiaries and affiliates of the Tokyo Marathon Foundation,
            contractors of the Tokyo Marathon Foundation such as cloud vendors
            and service companies, charity organizations to which applicants
            donate, hospitals and medical institutions, etc. and the personal
            data of applicants, participants, or Visitors will be processed by
            such third parties in order to carry out the purposes of use
            specified above.<br />
            As a result, personal data may be transferred to entities in
            countries or jurisdictions outside the EEA (including, without
            limitation, Japan, and the U.S., the same shall apply hereafter).<br />
            Please note that such countries or jurisdictions may not have the
            same data protection laws as the EEA, and many of the rights
            provided to data subjects in the EEA will not be given.<br />
            In addition to the above, in the case that the Tokyo Marathon
            Foundation provides personal data to any third party located in a
            country outside the EEA, other than countries that the European
            Commission has determined have an adequate level of data protection
            in accordance with Article 45 of the General Data Protection
            Regulation, we will ensure that adequate measures are taken
            concerning the protection of personal data by methods such as
            executing standard contract clauses based on the General Data
            Protection Regulation. For further information, including obtaining
            a copy of the documents used to protect personal data, please
            contact us at the addresses indicated in "8. Inquiries."<br />
            (7) Sensitive personal data<br />
            We process the data regarding the disability (visual disability,
            intellectual disability, and/or the use of a wheelchair), organ
            transplant and escort runner set forth in 1(1) above only to the
            extent necessary to specify the type of the race which participants
            participate (including announcement of the race result). <br />
            We process the medical data and health data set forth in 1(2) above
            only to the extent necessary (i) to prevent the spread of infectious
            diseases at the Events (including investigation of the presence or
            absence of infection and reporting to public health centers and
            other administrative agencies) and (ii) to provide medical care, to
            provide support in the wake of an accident including indemnity and
            to examine and improve the places for distributing emergency staff,
            the number and places for distribution of emergency vehicles, and
            any other matters concerning safety for future Events.<br />
            <br />
            4. Prevention of leakage, falsification loss or damage of personal
            data<br />
            When we process personal data, we shall endeavor to manage and store
            personal data in an accurate and up-to-date state and retain the
            personal data properly by taking appropriate security measures
            against loss, destruction, falsification and leakage.<br />
            In addition, we will exercise appropriate supervision over the
            employees processing the personal data or the contractors to whom we
            entrust the processing of the personal data.<br />
            <br />
            5. Continuous improvement of personal data protection management
            system<br />
            We will make necessary efforts to ensure the continuous improvement
            of our personal data protection management system.<br />
            <br />
            6. Cookies<br />
            We may use Visitors' cookies and collect Visitors' device
            information, software information, etc. on our website. We use this
            information as general statistical information for research and
            analysis of trends in the use of our website, not for personal
            identification.<br />
            <br />
            We use Google Analytics to understand and analyze how Visitors use
            our website. Google Analytics uses our cookies and collects
            information about Visitors. Information collected by Google
            Analytics is controlled by Google in accordance with its Terms of
            Service and Privacy Policy. For more information on how data is
            collected and processed by Google Analytics, please see "How Google
            uses information from sites or apps that use our services." If
            Visitors do not wish to have their information collected by Google
            Analytics from our website, Visitors can opt out by using the
            "Google Analytics Opt-Out Add-On."<br />
            (1) Google Analytics Terms of Service<br />
            <a
              href="https://marketingplatform.google.com/about/analytics/terms/us/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://marketingplatform.google.com/about/analytics/terms/us/</a
            >
            <br />
            (2) Google Privacy Policy<br />
            <a
              href="https://www.google.com/intl/en/policies/privacy/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://www.google.com/intl/en/policies/privacy/</a
            >
            <br />
            (3) How Google uses information from sites or apps that use our
            services<br />
            <a
              href="https://www.google.com/intl/en/policies/privacy/partners/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://www.google.com/intl/en/policies/privacy/partners/</a
            >
            <br />
            (4) Google Analytics Opt-Out Add-On<br />
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=en"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://tools.google.com/dlpage/gaoptout?hl=en</a
            >
            <br />
            <br />
            7. Rights of applicants, participants, and Visitors<br />
            The applicants, participants, and Visitors may make a request to the
            Tokyo Marathon Foundation for access to, rectification or erasure
            of, restriction of, or object to processing of their personal data,
            and may make a request for data portability.<br />
            The applicants, participants, and Visitors may raise an objection to
            the data protection authorities having jurisdiction over the Tokyo
            Marathon Foundation or the location of their domicile regarding the
            processing of their personal data.<br />
            Any request for access, rectification, or erasure of, restriction of
            use of the personal data held by the Tokyo Marathon Foundation shall
            be made in accordance with the Tokyo Marathon Foundation's privacy
            protection regulations and personal data processing guidance of the
            Tokyo Marathon Foundation (the "Guidance"). When requesting
            disclosure of personal data subject to disclosure, a "request for
            disclosure of personal data subject to disclosure" (pdf format) as
            set forth in the Guidance shall be submitted. Please note that it is
            necessary to install Adobe Acrobat Reader in order to view pdf
            files.<br />
            <br />
            8. Inquiries<br />
            The Tokyo Marathon Foundation determines the purpose and means of
            processing the personal data of applicants, participants, or
            Visitors.<br />
            In the event of any questions or concerns regarding this Privacy
            Policy or the processing of personal data by the Tokyo Marathon
            Foundation, or any requests concerning the access to, the
            rectification or erasure of, or the restriction of processing of
            personal data, or with regard to data portability, please contact us
            at the following help desk department by telephone, e-mail or
            mail.<br />
            <br />
            Tokyo Marathon Foundation Helpdesk<br />
            Nishishinjuku KS Building, 8F, 3-6-11 Nishishinjuku, Shinjuku-ku,
            Tokyo, 160-0023, Japan<br />
            Tel: +81-3-6279-0044 Fax: +81-3-6279-0144<br />
            Email: daihyo@tokyo42195.org<br />
            Office Hours: 10:00 a.m. - 5:00 p.m. (Except Saturdays, Sundays,
            National Holidays and Year-end through New Year Holiday)<br />
            <br />
            9. Revision of this Privacy Policy<br />
            The Tokyo Marathon Foundation may change the contents of this
            Privacy Policy when necessary. We will announce the revised Privacy
            Policy on this website when a revision is made.<br />
            Please check the contents of this Privacy Policy in a timely
            manner.<br />
            After the policy is revised, the applicants, participants, or
            Visitors shall be deemed to have agreed to the revised policy when
            they view this Privacy Policy.<br />
            <br />
            Effective date: April 1, 2013<br />
            Revised as of: July 11, 2022<br />
            Tokyo Marathon Foundation President/CEO<br />
            <br />
          </p>
        </section>
        <section class="sentence-section" id="eea">
          <h2>〇&nbsp;For applicants based outside the EEA</h2>
          <p class="privacy-sentence">
            Handling the personal information<br />
            The Tokyo Marathon Foundation (also referred to as “we” or “us”)
            provides runners, volunteers, and spectators with various
            opportunities to participate in various running events and sports
            activities held by us, including, but not limited to, the annual
            Tokyo Marathon held in March and the annual Tokyo Legacy Half
            Marathon held in October (the “Events”).<br />
            <br />
            The official membership club of the Tokyo Marathon Foundation, “ONE
            TOKYO,” provides members with various information on
            running/marathons. Also, through its charity programs, the Tokyo
            Marathon Foundation will continue contributing to the society.<br />
            <br />
            We understand the importance of the personal information and handle
            them with utmost care.<br />
            <br />
            The personal information and/or data that we collect from
            applicants/participants in connection with organizing the Events
            will be protected under various security measures as described
            below.<br />
            <br />
            1. Compliance with statutory and regulatory obligations and all
            applicable laws of Japan<br />
            We strive to use and strictly manage the personal information we
            collect, use, and disclose in compliance with the Tokyo Marathon
            Foundation’s privacy protection regulations, which are set in
            accordance with the Act on the Protection of Personal Information
            (Act No. 57 of May 30, 2003) and all other applicable statutory and
            regulatory obligations and laws.<br />
            <br />
            2. Collection, use and disclosure of personal information<br />
            The Tokyo Marathon Foundation collects, uses, and discloses the
            personal information we hold in compliance with our personal
            information protection management system, which is designed to
            adhere with the Personal Information Protection Management System
            requirements of the Japanese Industrial Standards set forth in JIS Q
            15001:2006.<br />
            Basically, we only collect personal information that
            applicants/participants provide voluntarily (authorized by the
            guardian in the case of minors under the age of eighteen (18)),
            including when applying and registering for the race.<br />
            The purpose of collecting and processing personal information will
            be specified in advance, and the Tokyo Marathon Foundation limits
            the collection and processing of personal information to what is
            necessary to achieve the previously advised purposes.<br />
            (1) Type of Information collected<br />
            The Tokyo Marathon Foundation will collect and process the following
            personal information.<br />
            ・When applying to participate in the Events, and/or when donating
            through the Events<br />
            <br />
            When applicants apply to participate in Events, we collect and
            process personal information of applicants (such as the applicants’
            name, sex, date of birth, age, address, telephone number, mobile
            number, email address, nationality, passport number (if applicant
            participates from overseas), emergency contact name, telephone
            number, relationship of such emergency contact with the applicants,
            whether applicants are registered with the Japan Association of
            Athletics Federations (JAAF), JAAF ID), race information of
            applicants (such as whether the applicant has any disability (visual
            disability, intellectual disability, and/or the use of a
            wheelchair), whether the applicant is an organ transplant recipient
            and whether the applicant needs an escort runner)(if applicable),
            donor information (such as name of company; address; telephone
            number; department; position; and contact person’s name, email
            address, and telephone number), and charity information (such as the
            name of the charity organizations to which applicants donate, amount
            of donation, and questionnaire responses); all of which are
            information provided to us by the applicants.<br />
            ・When selected applicants participate in the Events<br />
            We may collect information regarding the participants' health
            condition, vaccination history, PCR test results, and other
            infectious disease tests results prior to participating in the
            Events.<br />
            When participants participate in the Events, we collect and process
            personal information including each participant’s face photo,
            footage, race results and intermediate race record and estimated
            runner location information during the race, in addition to the
            personal information set forth above.<br />
            In order to verify the identity of the participants, we collect and
            process participants’ face photos; and we collect and process
            surveillance footage of the course during the race (participants’
            appearance may be recognized in such footage) for safety reasons.<br />
            ・When first aid or transfer to the hospital becomes necessary<br />
            Name and phone number of hotel where the participant is staying
            during the Events, currently treated conditions, current medication,
            allergies, name of injuries and diseases, symptoms, site of
            occurrence, the treatment received (if any) and any other necessary
            information will be collected and shared with the hospital which the
            participant is transferred to.<br />
            In addition, if a participant is taken to the hospital, name of
            injuries and diseases, course of the symptoms, course of treatment,
            and current prescription will be obtained from such hospital in
            order to respond in the wake of an accident, including indemnity,
            examination and improvement of the places for distributing emergency
            staff, the number and places for distribution of emergency vehicles,
            and any other matters concerning safety for future Events.<br />
            (2) Purposes of use of personal information<br />
            The Tokyo Marathon Foundation will process personal information in
            order to achieve the purposes notified or as set forth below.<br />
            ・For applicants to the Events and/or applicants making a donation
            through the Events:<br />
            - to select and registering participants;<br />
            - to improve our services and safety levels for
            applicants/participants; <br />
            - to provide information from the sponsors, supporting organizations
            and related organizations; and<br />
            - to provide personal information to the third parties as set forth
            in this Privacy Policy.<br />
            ・For participants in the Events:<br />
            In addition to the purposes set forth above, we will process
            participants’ personal information for the purposes set forth
            below:<br />
            - to verify the identity of the participants;<br />
            - to prevent the spread of infectious diseases (including
            investigation of the presence or absence of infection and reporting
            to public health centers and other administrative agencies);<br />
            - to ensure safety control of the marathon course;<br />
            - to deliver the Runner Handbook, results, and relevant information
            related to the Events to the participants;<br />
            - to announce intermediate record and estimated runner location
            information during the race and race results (including
            rankings);<br />
            - to subscribe to insurance;<br />
            - to provide medical care;<br />
            - to provide support in the wake of an accident, including
            indemnity;<br />
            - to examine and improve the places for distributing emergency
            staff, the number and places for distribution of emergency vehicles,
            and any other matters concerning safety for future Events;<br />
            - to hold and manage the Events; and<br />
            - to compile statistics from the Events.<br />
            (3) Transfer of personal information to third parties<br />
            The Tokyo Marathon Foundation basically does not provide personal
            information to third parties except as otherwise provided by laws
            and regulations or with the prior consent of data subjects.<br />
            Meanwhile, the Tokyo Marathon Foundation may provide the personal
            information to third parties (including those located outside of
            Japan) if provision of such information is necessary to public
            health centers, other administrative agencies, affiliates (including
            Abbott World Marathon Majors LLC located in the United States,
            operating the Abbott World Marathon Majors; please see the
            information provided in accordance with Article 28, Paragraph 2 of
            the Act on the Protection of Personal Information below), the
            charity organizations to which participants, and contractors of the
            Tokyo Marathon Foundation within the scope relevant to the
            management of the Events (including implementation of measures to
            prevent the spread of infectious diseases), in case required to
            provide such information to insurance companies in order to apply
            for insurance, in case of transferring the provided information
            regarding health or medical care to the hospital which the
            participant is taken to, or in case of announcing the information
            relating to race record via TV, newspaper, magazine, the internet
            and the like.<br />
            <br />
            We may disclose personal information set forth in 2(1) to a third
            party located in the following country with prior consent:<br />
            (a) Name of the country where the third party located<br />
            United States of America<br />
            (b) Information on the data privacy regulations of the country<br />
            Please review the URL below.<br />
            <a
              href="https://www.ppc.go.jp/files/pdf/USA_report.pdf"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >Federal law</a
            >
            and
            <a
              href="https://www.ppc.go.jp/files/pdf/illinoi_report.pdf"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >Illinois state law</a
            >
            <br />
            (c) Measures to protect personal information taken by the third
            party<br />
            The third party implements security measures in accordance with all
            OECD 8 Privacy Principles stated in the “Guidelines on the
            Protection of Privacy and Transborder Flows of Personal Data.”
            <br />
            <br />
            (4) Sensitive personal information<br />
            We process the information regarding the disability (visual
            disability, intellectual disability, and/or the use of a
            wheelchair), organ transplant and escort runner set forth in 2(1)
            above only to the extent necessary to specify the type of the race
            which participants participates (including announcement of the race
            result). We process the medical information and health information
            set forth in 2(1) above only to the extent necessary (i) to prevent
            the spread of infectious diseases at the Events (including
            investigation of the presence or absence of infections and reporting
            to public health centers and other competent administrative
            agencies) and (ii) to provide medical care, to provide support in
            the wake of an accident including indemnity and to examine and
            improve the places for distributing emergency staff, the number and
            places for distribution of emergency vehicles, and any other matters
            concerning safety for future Events.<br />
            <br />
            3. Prevention of leakage, falsification loss, or damage of personal
            information<br />
            When we process personal information, we shall endeavor to manage
            and store personal information in an accurate and up-to-date state
            and retain the information properly by taking appropriate security
            measures against loss, destruction, falsification, and leakage. For
            details of our safety control measures for personal information,
            please contact the address listed in “7. Inquiries.”<br />
            In addition, we will exercise appropriate supervision over the
            employees processing the personal information or the contractors
            whom we entrust the processing of the personal information. <br />
            <br />
            The name of the business operator handling personal information is
            the Tokyo Marathon Foundation, and our address and name of the
            representative can be found
            <a
              href="https://tokyo42195.org/en/aboutus/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >here</a
            >
            .<br />
            <br />
            4. Continuous improvement of personal information protection
            management system<br />
            We will make necessary efforts to ensure the continuous improvement
            of our personal information protection management system.<br />
            <br />
            5. Cookies<br />
            We may use cookies of visitors to our website (“Visitors”) and
            collect Visitors’ device information, software information, etc. on
            our website. We use this information as general statistical
            information for research and analysis of trends in the use of our
            website, not for personal identification.<br />
            <br />
            We use Google Analytics to understand and analyze how Visitors use
            our website. Google Analytics uses our cookies and collects
            information about Visitors. Information collected by Google
            Analytics is controlled by Google in accordance with its Terms of
            Service and Privacy Policy. For more information on how data is
            collected and processed by Google Analytics, please see “How Google
            uses information from sites or apps that use our services.” If
            visitors do not wish to have their information collected by Google
            Analytics from our website, Visitors can opt out by using the
            “Google Analytics Opt-Out Add-On.”<br />
            (1) Google Analytics Terms of Service<br />
            <a
              href="https://marketingplatform.google.com/about/analytics/terms/us/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://marketingplatform.google.com/about/analytics/terms/us/</a
            >
            <br />
            (2) Google Privacy Policy<br />
            <a
              href="https://www.google.com/intl/en/policies/privacy/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://www.google.com/intl/en/policies/privacy/</a
            >
            <br />
            (3) How Google uses information from sites or apps that use our
            services<br />
            <a
              href="https://www.google.com/intl/en/policies/privacy/partners/"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://www.google.com/intl/en/policies/privacy/partners/</a
            >
            <br />
            (4) Google Analytics Opt-Out Add-On<br />
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=en"
              target="_blank"
              rel="noopener"
              style="text-decoration: underline"
              >https://tools.google.com/dlpage/gaoptout?hl=en</a
            >
            <br />
            6. Making requests regarding the disclosure of your personal
            information subject to disclosure<br />
            Any request for access (including to records on third-party
            provision), rectification, or suspension of use of personal
            information or provision of personal information held by the Tokyo
            Marathon Foundation to a third party shall be made in accordance
            with the Tokyo Marathon Foundation’s privacy protection regulations
            and personal information handling guidance of the Tokyo Marathon
            Foundation (the “Guidance”). When requesting disclosure of personal
            information subject to disclosure, a “request for disclosure of
            personal information subject to disclosure” (pdf format) as set
            forth in the Guidance shall be submitted.<br />
            Please note that it is necessary to install Adobe Acrobat Reader in
            order to view pdf files.<br />
            *To obtain a copy of your personal data, you will need to bear the
            necessary cost set by the Tokyo Marathon Foundation’s privacy
            protection regulations. <br />
            <br />
            7. Inquiries<br />
            If you have any complaint or consultation regarding the processing
            of personal information, please contact us at the following help
            desk department by telephone, e-mail or mail.<br />
            <br />
            Tokyo Marathon Foundation Helpdesk<br />
            Nishishinjuku KS Building, 8F, 3-6-11 Nishishinjuku, Shinjuku-ku,
            Tokyo, 160-0023, Japan<br />
            Tel: +81-3-6279-0044 Fax: +81-3-6279-0144<br />
            Email: daihyo@tokyo42195.org<br />
            Office Hours: 10:00 a.m. - 5:00 p.m. (Except Saturdays, Sundays,
            National Holidays and Year-end through New Year Holiday)<br />
            <br />
            8. Revision of this Privacy Policy<br />
            The Tokyo Marathon Foundation may change the contents of this
            Privacy Policy when necessary. We will announce the revised Privacy
            Policy on this website when a revision is made.<br />
            Please check the contents of this Privacy Policy in a timely
            manner.<br />
            After the policy is revised, the applicants/participants shall be
            deemed to have agreed to the revised policy when the
            applicants/participants view this Privacy Policy.<br />
            <br />
            Effective date: April 1, 2013<br />
            Revised as of: July 11, 2022<br />
            Tokyo Marathon Foundation President/CEO<br />
            <br />
          </p>
        </section>
      </template>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/sp/Wrapper";
import PrivacySentence from "../../../assets/constants/privacy/privacy";
export default {
  computed: {
    PrivacySentence: function () {
      return PrivacySentence;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
  },
  name: "Privacy",
};
</script>

<style scoped>
.main {
  .page-title {
    margin: 40px 0 0 0;
    line-height: 1.25;
    padding: 0 0 0 15px;
    border-left: solid 8px var(--defaultBlackColor);
    font-size: 32px;
    font-weight: 900;
  }
  .scroll-list {
    margin: 40px 0 0 0;
    &__button {
      margin: 20px 0 0 0;
      padding: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 1px #000;
      font-size: 18px;
      font-weight: 500;
      color: #000;
      text-align: center;
    }
  }
  .sentence-section {
    margin: 25px 0 0 0;
    padding: 15px 0 0 0;
    .privacy-sentence {
      margin: 20px 0 0 0;
      line-height: 1.6;
      font-size: 14px;
    }
    .text-align-right {
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/privacy/Privacy.vue